export default "<div [ngSwitch]=\"loading\">\r\n    <c-loading-pulse *ngSwitchCase=\"'pulse'\"></c-loading-pulse>\r\n</div>\r\n"